module.exports = __webpack_public_path__ + "static/img/greet_img_sayhi.a85d4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/moment/greet_img_sayhi.png
// module id = PMQp
// module chunks = 28